/* Raptor Recommendations — client renderer for sections/raptor-recs.liquid.
   Fetches products (native recommendations API on product pages, collection
   JSON otherwise), filters to in-stock items not already in the cart,
   shuffles per visit, renders carousel cards, and adds via /cart/add.js. */
(function () {
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  // "$1,007.95" (spec v2.17 cards); falls back to the plain form
  function money(cents) {
    var v = cents / 100;
    try { return '$' + v.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return '$' + v.toFixed(2); }
  }
  // Two card rows on one product page (Customers also viewed, You may also
  // like) never repeat a product: whichever renders first keeps it.
  var SHOWN = window.__rrRecsShown || (window.__rrRecsShown = {});

  // Measurement (raptor-recs step 1): which rows are seen, clicked and added,
  // smart ranking vs Shopify's lists. Product ids, row and position only: no
  // visitor, session or customer data. Beacons wait for the first real scroll,
  // tap or key, so headless crawlers that never interact are not counted.
  // 20% of visitors keep Shopify's lists (control) so the difference is measurable.
  var AB = (function () {
    var key = 'rr-ab-v1', v = null;
    try { v = localStorage.getItem(key); } catch (e) { /* storage blocked */ }
    if (v !== 'smart' && v !== 'control') {
      v = Math.random() < 0.2 ? 'control' : 'smart';
      try { localStorage.setItem(key, v); } catch (e) { /* per-page bucket then */ }
    }
    return v;
  })();
  var evQueue = [], evEngaged = false, evTimer = null;
  function evSend(useBeacon) {
    evTimer = null;
    if (!evEngaged || !evQueue.length) return;
    var body = JSON.stringify({ v: 1, ab: AB, ev: evQueue.splice(0, 40) });
    var url = '/apps/rr-recs/event';
    try {
      if (useBeacon && navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
      else fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body }).catch(function () {});
    } catch (e) { /* measurement never breaks the page */ }
    if (evQueue.length) evSchedule();
  }
  function evSchedule() { if (!evTimer) evTimer = setTimeout(function () { evSend(false); }, 1500); }
  function rrEvent(e) { if (evQueue.length < 200) evQueue.push(e); if (evEngaged) evSchedule(); }
  ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'].forEach(function (t) {
    window.addEventListener(t, function () { if (!evEngaged) { evEngaged = true; evSchedule(); } }, { passive: true, once: true });
  });
  window.addEventListener('pagehide', function () { evSend(true); });

  function normalize(p) {
    var variant = null;
    for (var i = 0; i < (p.variants || []).length; i++) {
      if (p.variants[i].available) { variant = p.variants[i]; break; }
    }
    if (!variant || p.available === false) return null;
    var img = p.featured_image || (p.images && p.images[0]) || null;
    if (img && typeof img === 'object') img = img.src || null;
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      productType: p.product_type || p.type || '',
      vendor: p.vendor || '',
      url: p.url || ('/products/' + p.handle),
      image: img,
      variantId: variant.id,
      price: typeof variant.price === 'number' ? variant.price : Math.round(parseFloat(variant.price) * 100),
      compareAt: (function () {
        // Penny-off compare-at feed artifacts: mirror the trivial-sale gate
        // in product.liquid / z__jsProduct.js (>= $1 AND floored >= 1% saved).
        if (!variant.compare_at_price) return null;
        var gvCap = typeof variant.compare_at_price === 'number' ? variant.compare_at_price : Math.round(parseFloat(variant.compare_at_price) * 100);
        var gvPrice = typeof variant.price === 'number' ? variant.price : Math.round(parseFloat(variant.price) * 100);
        var gvDelta = gvCap - gvPrice;
        if (gvDelta < 100 || Math.floor((gvDelta * 100) / gvCap) < 1) return null;
        return gvCap;
      })()
    };
  }

  function squareImage(url) {
    if (!url) return null;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=480';
  }

  function fetchJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // raptor-recs service (Fly.io, via the /apps/rr-recs app proxy): a ranked list of
  // same-vehicle add-ons plus `avoid` / `avoid_types`, products and product types it rejected
  // for this one (wrong vehicle, bolt pattern or lug count, doesn't fit, unrelated).
  // Resolves { list, avoid, avoidTypes }, or null
  // (caller uses Shopify's lists alone) when the proxy is missing, slow or still computing.
  function smartSource(path) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 2500);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch('/apps/rr-recs/' + path, { headers: { Accept: 'application/json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        clearTimeout(timer);
        if (!d || d.status !== 'ready') return null;
        // Add-ons first; on the product page (`more`, pdp only) other parts for the same car follow them.
        var picks = (d.goes || []).map(function (g) { return { h: g.handle, src: 'smart' }; })
          .concat((d.more || []).map(function (g) { return { h: g.handle, src: 'more' }; }))
          .slice(0, 12);
        if (!picks.length) return null;
        return Promise.all(picks.map(function (g) {
          return fetchJSON(root + 'products/' + encodeURIComponent(g.h) + '.js').then(function (p) {
            if (p) p.__rrSrc = g.src;
            return p;
          });
        })).then(function (list) {
          list = list.filter(Boolean);
          return list.length ? { list: list, avoid: d.avoid || [], avoidTypes: d.avoid_types || [],
            skipFamilies: d.skip_families || [] } : null;
        });
      })
      .catch(function () { clearTimeout(timer); return null; });
  }

  function fetchCollections(handles, perCollection) {
    var jobs = handles.filter(Boolean).map(function (h) {
      return fetchJSON('/collections/' + encodeURIComponent(h.trim()) + '/products.json?limit=' + perCollection)
        .then(function (d) { return (d && d.products) || []; });
    });
    return Promise.all(jobs).then(function (lists) {
      return [].concat.apply([], lists);
    });
  }

  function init(root) {
    var track = root.querySelector('[data-rr-track]');
    if (!track) return;
    var mode = root.dataset.mode || 'auto';
    var layout = root.dataset.layout || 'carousel';
    var intent = root.dataset.intent || 'related';
    var handles = (root.dataset.collections || '').split(',').filter(Boolean);
    var maxItems = parseInt(root.dataset.maxItems, 10) || 8;
    var productId = root.dataset.productId;
    var showStars = root.dataset.showStars === 'true';
    var showQty = root.dataset.showQty === 'true';

    // Cart first: it powers both the exclude-list and, on the cart page,
    // the recommendation seed (first item) when no product context exists.
    fetchJSON('/cart.js').then(function (cart) {
      var cartItems = (cart && cart.items) || [];
      var seedIds = [];
      if (productId) seedIds.push(String(productId));
      if (!seedIds.length && mode === 'auto') {
        cartItems.slice(0, 3).forEach(function (it) {
          if (seedIds.indexOf(String(it.product_id)) === -1) seedIds.push(String(it.product_id));
        });
      }
      var seedId = seedIds[0] || null;

      var sourcePromise;
      var merge = root.dataset.merge === 'true';
      var smart = root.dataset.smart === 'true';
      var smartUsed = false;
      var smartPath = null;
      if (smart && merge && seedId) smartPath = 'pdp?product_id=' + seedId;
      else if (smart && mode === 'auto' && seedIds.length && !productId) smartPath = 'cart?ids=' + seedIds.join(',');
      // Rows eligible for smart ranking are measured; the control bucket keeps Shopify's lists.
      var evRow = smartPath ? (merge ? 'pdp' : 'cart') : null;
      var evSeed = merge ? String(seedId) : String(seedIds[0] || '');
      if (smartPath && AB === 'control') smartPath = null;
      if (evRow === 'pdp') rrEvent({ k: 'pv', p: evSeed });
      if (merge && seedId) {
        // Spec v2.18 6F.10: ONE row on product pages. "Customers also viewed"
        // (Shopify Search & Discovery complementary products) first, then
        // "You may also like" (Shopify's related-products algorithm); order
        // kept, duplicates, this product and cart items dropped below.
        var mbase = '/recommendations/products.json?product_id=' + seedId + '&limit=12';
        sourcePromise = Promise.all([
          fetchJSON(mbase + '&intent=complementary'),
          fetchJSON(mbase + '&intent=related')
        ]).then(function (res) {
          var a = (res[0] && res[0].products) || [];
          var b = (res[1] && res[1].products) || [];
          a.forEach(function (p) { if (p) p.__rrSrc = 'viewed'; });
          return a.concat(b);
        });
      } else if (mode === 'auto' && seedIds.length) {
        sourcePromise = Promise.all(seedIds.map(function (sid) {
          var base = '/recommendations/products.json?product_id=' + sid + '&limit=' + Math.max(12, maxItems);
          return fetchJSON(base + '&intent=' + intent)
            .then(function (d) {
              var got = (d && d.products) || [];
              if (got.length >= 2 || intent === 'related') return got;
              return fetchJSON(base + '&intent=related').then(function (d2) {
                return got.concat((d2 && d2.products) || []);
              });
            });
        })).then(function (lists) {
          var recs = [].concat.apply([], lists);
          if (recs.length >= 4 || !handles.length) return recs;
          return fetchCollections(handles, 30).then(function (extra) { return recs.concat(extra); });
        });
      } else {
        sourcePromise = fetchCollections(handles, 30);
      }

      if (smartPath) {
        // Smart picks first (as many as the service has), then Shopify's own list fills
        // the row, minus anything the service rejected for this product.
        var fallback = sourcePromise;
        sourcePromise = Promise.all([smartSource(smartPath), fallback]).then(function (res) {
          var smartRes = res[0], rest = res[1] || [];
          if (!smartRes) return rest;
          var skip = {}, skipType = {};
          smartRes.avoid.concat(smartRes.list.map(function (p) { return p.id; })).forEach(function (id) { skip[String(id)] = true; });
          smartRes.avoidTypes.forEach(function (t) { skipType[t] = true; });
          // cart only: Shopify's fill never adds more of what's already in the cart (another wheel)
          var skipFam = {};
          smartRes.skipFamilies.forEach(function (f) { skipFam[f] = true; });
          var fam = function (t) { return (t || '').split(' - ')[0].trim().toLowerCase(); };
          rest = rest.filter(function (p) {
            var t = p && (p.product_type || p.type || '');
            return p && !skip[String(p.id)] && !skipType[t] && !skipFam[fam(t)];
          });
          rest.forEach(function (p) { p.__rrSrc = 'shopify'; });
          smartUsed = true;
          return smartRes.list.concat(rest);
        });
      }

      sourcePromise.then(function (products) {
        products = products || [];
      var inCart = {};
      ((cart && cart.items) || []).forEach(function (it) { inCart[it.product_id] = true; });

      // Never recommend service/utility products.
      var EXCLUDED_TYPES = /shipping protection|gift card|insurance|route package/i;

      var seedTypes = {};
      var seedVendors = {};
      if (root.dataset.productType) seedTypes[root.dataset.productType] = true;
      if (root.dataset.productVendor) seedVendors[root.dataset.productVendor] = true;
      cartItems.forEach(function (it) {
        if (it.product_type) seedTypes[it.product_type] = true;
        if (it.vendor) seedVendors[it.vendor] = true;
      });

      var seen = {};
      var pool = [];
      products.forEach(function (p) {
        if (!p || seen[p.id] || inCart[p.id]) return;
        if (String(p.id) === String(seedId || productId)) return;
        seen[p.id] = true;
        var n = normalize(p);
        if (!n) return;
        if (EXCLUDED_TYPES.test(n.productType) || EXCLUDED_TYPES.test(n.title)) return;
        n.src = p.__rrSrc === 'smart' || p.__rrSrc === 'more' ? p.__rrSrc : 'shopify';
        pool.push(n);
      });

      // Relevance tiers: same product type as anything in context, then same
      // vendor, then the rest. Tier 3 only BACKFILLS when relevant matches
      // are scarce (fewer than MIN_RELEVANT) — otherwise oddballs are cut,
      // not just sunk.
      var MIN_RELEVANT = 4;
      var t1 = [], t2 = [], t3 = [];
      pool.forEach(function (n) {
        if (n.productType && seedTypes[n.productType]) t1.push(n);
        else if (n.vendor && seedVendors[n.vendor]) t2.push(n);
        else t3.push(n);
      });
      // Smart rows arrive ranked and already vehicle-filtered: keep their order.
      var items = (merge || smartUsed) ? pool.slice() : shuffle(t1).concat(shuffle(t2));
      // data-strict (spec v2.17: Customers also viewed as a card row) keeps the
      // compact rows' relevance rule in the card layout
      if (layout === 'compact' || root.dataset.strict === 'true') {
        // Prime placement: relevant matches only, hide entirely when thin.
        if (items.length < 2) return;
      } else if (!merge && !smartUsed && items.length < MIN_RELEVANT) {
        items = items.concat(shuffle(t3).slice(0, MIN_RELEVANT - items.length));
      }
      items = items.filter(function (it) { return !SHOWN[it.id]; });
      if ((layout === 'compact' || root.dataset.strict === 'true') && items.length < 2) return;
      items = items.slice(0, maxItems);
      if (!items.length) return;
      items.forEach(function (it) { SHOWN[it.id] = true; });

      var smartShown = items.filter(function (it) { return it.src === 'smart'; }).length;
      var evVariant = smartUsed ? (smartShown >= 4 ? 'smart' : (smartShown ? 'mixed' : 'fallback'))
        : (AB === 'control' ? 'control' : 'fallback');
      var evBase = function (k, extra) {
        var e = { k: k, r: evRow, x: evVariant, s: evSeed };
        for (var key in extra) e[key] = extra[key];
        return e;
      };
      items.forEach(function (item, pos) {
        if (layout === 'compact') {
          var row = document.createElement('div');
          row.className = 'rr-pair';
          var rImg = document.createElement('img');
          rImg.className = 'rr-pair__img';
          rImg.loading = 'lazy';
          rImg.alt = item.title;
          rImg.src = squareImage(item.image) || '';
          row.appendChild(rImg);
          var info = document.createElement('div');
          info.className = 'rr-pair__info';
          var tl = document.createElement('a');
          tl.className = 'rr-pair__title';
          tl.href = item.url;
          tl.textContent = item.title;
          info.appendChild(tl);
          var pr = document.createElement('div');
          pr.className = 'rr-pair__price';
          pr.textContent = money(item.price);
          if (item.compareAt && item.compareAt > item.price) {
            var cm = document.createElement('span');
            cm.className = 'rr-pair__compare';
            cm.textContent = money(item.compareAt);
            pr.appendChild(cm);
          }
          info.appendChild(pr);
          row.appendChild(info);
          var addBtn = document.createElement('button');
          addBtn.type = 'button';
          addBtn.className = 'rr-pair__add';
          addBtn.textContent = 'Add';
          addBtn.addEventListener('click', function () {
            addBtn.disabled = true;
            addBtn.textContent = '…';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: item.variantId, quantity: 1 })
            }).then(function (r) {
              if (!r.ok) throw new Error('add failed');
              addBtn.textContent = '✓';
              if (window.location.pathname.indexOf('/cart') === -1) {
                setTimeout(function () { window.location.href = '/cart'; }, 350);
              }
            }).catch(function () {
              addBtn.disabled = false;
              addBtn.textContent = 'Add';
            });
          });
          row.appendChild(addBtn);
          track.appendChild(row);
          return;
        }
        var onSale = !!(item.compareAt && item.compareAt > item.price);
        var card = document.createElement('div');
        card.className = 'rr-card' + (onSale ? ' rr-card--sale' : '');

        var link = document.createElement('a');
        link.className = 'rr-card__media';
        link.href = item.url;
        if (evRow) link.addEventListener('click', function () { rrEvent(evBase('click', { i: String(item.id), pos: pos, o: item.src })); });
        if (onSale) {
          // Sale label: first child of the image wrapper so it sits over the
          // top-left corner. Styled in sections/raptor-recs.liquid.
          var badge = document.createElement('span');
          badge.className = 'rr-card__badge';
          badge.textContent = 'Sale';
          link.appendChild(badge);
        }
        var img = document.createElement('img');
        img.className = 'rr-card__img';
        img.loading = 'lazy';
        img.alt = item.title;
        img.src = squareImage(item.image) || '';
        link.appendChild(img);
        card.appendChild(link);

        var titleLink = document.createElement('a');
        titleLink.className = 'rr-card__title';
        titleLink.href = item.url;
        if (evRow) titleLink.addEventListener('click', function () { rrEvent(evBase('click', { i: String(item.id), pos: pos, o: item.src })); });
        titleLink.textContent = item.title;
        card.appendChild(titleLink);

        if (showStars) {
          var stars = document.createElement('div');
          stars.className = 'rr-card__stars';
          stars.setAttribute('data-rr-handle', item.handle);
          card.appendChild(stars);
        }

        var price = document.createElement('div');
        price.className = 'rr-card__price';
        price.textContent = money(item.price);
        if (item.compareAt && item.compareAt > item.price) {
          var cmp = document.createElement('span');
          cmp.className = 'rr-card__compare';
          cmp.textContent = money(item.compareAt);
          price.appendChild(cmp);
        }
        card.appendChild(price);

        var qtyInput = null;
        if (showQty) {
          var qtyWrap = document.createElement('div');
          qtyWrap.className = 'rr-card__qty';
          var minus = document.createElement('button');
          minus.type = 'button'; minus.textContent = '−';
          minus.className = 'rr-card__qty-btn';
          minus.setAttribute('aria-label', 'Decrease quantity');
          qtyInput = document.createElement('input');
          qtyInput.type = 'text'; qtyInput.inputMode = 'numeric';
          qtyInput.value = '1';
          qtyInput.className = 'rr-card__qty-input';
          qtyInput.setAttribute('aria-label', 'Quantity');
          var plus = document.createElement('button');
          plus.type = 'button'; plus.textContent = '+';
          plus.className = 'rr-card__qty-btn';
          plus.setAttribute('aria-label', 'Increase quantity');
          minus.addEventListener('click', function () {
            qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
          });
          plus.addEventListener('click', function () {
            qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1));
          });
          qtyWrap.appendChild(minus); qtyWrap.appendChild(qtyInput); qtyWrap.appendChild(plus);
          card.appendChild(qtyWrap);
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rr-card__add';
        /* v2.16 (spec 5.2/5.3): the label lives in span.text so the "✓ Added"
           flip (rr-motion.js, on gv:cart:added) can slide it away */
        var btnLabel = document.createElement('span');
        btnLabel.className = 'text';
        btnLabel.textContent = 'Add to cart';
        btn.appendChild(btnLabel);
        btn.addEventListener('click', function () {
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          btn.disabled = true;
          btnLabel.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.variantId, quantity: qty })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            if (evRow) rrEvent(evBase('add', { i: String(item.id), pos: pos, o: item.src }));
            btnLabel.textContent = 'Add to cart';
            try {
              document.dispatchEvent(new CustomEvent('gv:cart:added', { detail: { button: btn } }));
            } catch (e) { btnLabel.textContent = 'Added ✓'; }
            // Cart page: the cart__main /cart/add sniffer reloads and the ETA
            // machinery re-runs. Product/other pages: go to the cart once the
            // "✓ Added" flip has played (the add has already succeeded).
            if (window.location.pathname.indexOf('/cart') === -1) {
              /* v2.18 6L E3: stay on the page; the count pops and the button says Added */
              try { document.dispatchEvent(new CustomEvent('rr:recs:added')); } catch (e) { /* old browsers */ }
            }
          }).catch(function () {
            btn.disabled = false;
            btnLabel.textContent = 'Add to cart';
          });
        });
        card.appendChild(btn);

        track.appendChild(card);
      });

      root.style.display = 'block';

      if (evRow && items.length) {
        var evIds = items.map(function (it) { return String(it.id); });
        var evSrc = items.map(function (it) { return it.src; });
        var sendView = function () { rrEvent(evBase('rowview', { i: evIds, io: evSrc })); };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); sendView(); }
          }, { threshold: 0.4 });
          io.observe(root);
        } else {
          sendView();
        }
      }

      // Compact rotator: one row visible at a time, arrows cycle (wrap).
      if (layout === 'compact') {
        var rows = [].slice.call(track.querySelectorAll('.rr-pair'));
        var nav = root.querySelector('.rr-pairs__nav');
        if (rows.length > 1 && nav) {
          var active = 0;
          function showRow(i) {
            active = (i + rows.length) % rows.length;
            rows.forEach(function (r2, k) {
              if (k === active) r2.classList.remove('rr-pair--hidden');
              else r2.classList.add('rr-pair--hidden');
            });
          }
          nav.style.display = '';
          var prevB = nav.querySelector('[data-rr-prev]');
          var nextB = nav.querySelector('[data-rr-next]');
          if (prevB) prevB.addEventListener('click', function () { showRow(active - 1); });
          if (nextB) nextB.addEventListener('click', function () { showRow(active + 1); });
          showRow(0);
        }
      }

      // Judge.me stars for dynamically injected cards: batchRenderBadges
      // takes [{productHandle, badgePlaceholder}] and fetches each rating.
      // Their SDK may load after us — poll briefly. Badges that come back
      // "No reviews" are cleared (the reserved row height keeps alignment).
      if (showStars) {
        var attempts = 0;
        (function renderStars() {
          if (!window.jdgm || typeof window.jdgm.batchRenderBadges !== 'function') {
            // Pages without native Judge.me widgets (e.g. cart) only get the
            // loader stub — pull the core SDK in ourselves, once, using the
            // loader's own URL scheme.
            var j = window.jdgm;
            if (j && typeof j.loadJS === 'function' && !window.__rrJdgmCoreRequested) {
              window.__rrJdgmCoreRequested = true;
              var coreUrl = j.CDN_BASE_URL
                ? j.CDN_BASE_URL + 'shopify_v2.js'
                : (j.CDN_HOST || 'https://cdn.judge.me/') + 'shopify_v2.js';
              try { j.loadJS(coreUrl, function () {}); } catch (e) { /* noop */ }
            }
            if (attempts++ < 20) setTimeout(renderStars, 500);
            return;
          }
          var placeholders = [].slice.call(root.querySelectorAll('.rr-card__stars[data-rr-handle]'));
          try {
            window.jdgm.batchRenderBadges(placeholders.map(function (el) {
              return { productHandle: el.getAttribute('data-rr-handle'), badgePlaceholder: el };
            }));
          } catch (e) { return; }
          setTimeout(function () {
            var empty = placeholders.filter(function (el) { return !el.innerHTML; });
            if (empty.length) {
              try {
                window.jdgm.batchRenderBadges(empty.map(function (el) {
                  return { productHandle: el.getAttribute('data-rr-handle'), badgePlaceholder: el };
                }));
              } catch (e) { /* noop */ }
            }
            setTimeout(function () {
              placeholders.forEach(function (el) {
                if (/no reviews/i.test(el.textContent || '')) el.innerHTML = '';
              });
            }, 2500);
          }, 4000);
        })();
      }

      var prev = root.querySelector('.rr-recs__arrow--prev');
      var next = root.querySelector('.rr-recs__arrow--next');
      function step() {
        var card = track.querySelector('.rr-card');
        return card ? card.getBoundingClientRect().width + 14 : 240;
      }
      function updateArrows() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-raptor-recs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
